import CryptoJS from 'crypto-js'

// des加密（这种方法有密文）
const encryptDes = (message, key = 'hengyong') => {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  //转base64 再encode下
  const encryptedStr = encrypted.toString()
  return encodeURIComponent(encryptedStr)
}

//des解密
const decryptDes = (ciphertext, key = 'hengyong') => {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  // direct decrypt ciphertext
  const decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Base64.parse(decodeURIComponent(ciphertext))
  }, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export {
  encryptDes,
  decryptDes
}


// WEBPACK FOOTER //
// ./src/utils/des.js